import React from 'react';
import { FireIcon, ChartBarIcon, CurrencyDollarIcon } from '@heroicons/react/24/outline';
import CommonPageHeader from '../components/common/CommonPageHeader';

const FleetFuel: React.FC = () => {
  return (
    <div className="space-y-6">
      <CommonPageHeader
        title="Üzemanyag kezelés"
        subtitle="Tankolási napló, fogyasztás statisztika és költségek"
        icon={FireIcon}
      />

      {/* Flotta modul overlay */}
      <div className="relative">
        <div className="absolute inset-0 bg-gray-900/5 dark:bg-gray-900/20 backdrop-blur-[0.5px] z-10 rounded-lg flex items-center justify-center">
          <div className="bg-white/95 dark:bg-gray-800/95 px-8 py-6 rounded-xl shadow-2xl border border-gray-200 dark:border-gray-700 max-w-md text-center">
            <div className="w-16 h-16 bg-gradient-to-r from-primary-400 to-primary-600 rounded-full flex items-center justify-center mx-auto mb-4">
              <span className="text-3xl">🚗</span>
            </div>
            <h3 className="text-xl font-bold text-gray-900 dark:text-white mb-2">Flotta Modul</h3>
            <p className="text-sm font-medium text-gray-700 dark:text-gray-300 mb-4">
              Ez a funkció a Flotta modul részét képezi
            </p>
            <p className="text-xs text-gray-600 dark:text-gray-400">
              Az Üzemanyag kezelés modul külön megrendelés tárgya.
            </p>
          </div>
        </div>

        {/* Teljes működő tartalom (elmosódva) */}
        <div className="pointer-events-none opacity-70 space-y-6">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow">
              <FireIcon className="w-8 h-8 text-orange-600 mb-2" />
              <h3 className="font-semibold mb-1">Havi tankolás</h3>
              <p className="text-2xl font-bold">2,450 L</p>
            </div>
            <div className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow">
              <ChartBarIcon className="w-8 h-8 text-blue-600 mb-2" />
              <h3 className="font-semibold mb-1">Átlag fogyasztás</h3>
              <p className="text-2xl font-bold">8.5 L/100km</p>
            </div>
            <div className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow">
              <CurrencyDollarIcon className="w-8 h-8 text-green-600 mb-2" />
              <h3 className="font-semibold mb-1">Havi költség</h3>
              <p className="text-2xl font-bold">1,250,000 Ft</p>
            </div>
          </div>

          <div className="bg-white dark:bg-gray-800 rounded-lg shadow p-6">
            <h3 className="text-lg font-semibold mb-4">Tankolási előzmények</h3>
            <div className="space-y-3">
              {[1, 2, 3].map((i) => (
                <div key={i} className="border-l-4 border-orange-500 pl-4 py-2">
                  <p className="font-medium">45 L • 22,500 Ft</p>
                  <p className="text-sm text-gray-600">ABC-123 • MOL • 2024. 01. 15.</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FleetFuel;
